
<div class="hpanel margin-bottom-5">
    <div class="panel-heading hbuilt wig-c">
      {{ headerTitle }}
    </div>
    <div class="panel-body">
      <div class="row">
        <div class="col-sm-12">

          <div class="col-sm-4">
             <img   class="img b-radius-social" height= "51px" width= "51px" src="assets/images/gallery/twitter.JPG"  alt="">
           </div>
           <div class="col-sm-4">
            <img   class="img b-radius-social" height="50px" width="50px" src="assets/images/gallery/facebook.png"  alt="">
           </div>
           <div class="col-sm-4">
            <img   class="img b-radius-social" height="51px" width="51px" src="assets/images/gallery/linkedin.jpg"  alt="">
          </div>
         </div>
      </div>
    </div>
  </div>
  